import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import * as Fields from 'support/fields'
import * as UI from 'ui'
import { Fieldset } from 'layouts'
import { Can, CanEither } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import CancelEmploymentForm from 'pages/app/users/partials/CancelEmploymentForm'
import WhenModelValue from 'support/conditionals/WhenModelValue'
import StopEmploymentCancellationForm from 'pages/app/users/partials/StopEmploymentCancellationForm'
import { WhenLoaded } from '@morningtrain/react-resources'
import FiredAtBadge from 'pages/app/users/partials/FiredAtBadge'
import PinEditableFiled from "support/fields/custom/PinEditableField";

export default function SystemAccessFieldset ({ create = false }) {
  return (
          <CanEither permissions={[Permissions.EMPLOYMENTS_MANAGE_USERS_FULL, Permissions.EMPLOYMENTS_MANAGE_USERS]}>
            <UI.CardWithHeader header={<Translation name="headers.system_access"/>}>

              <Fieldset cols={2}>

                <Can permission={Permissions.EMPLOYMENTS_MANAGE_USERS_FULL}>
                  <Fields.RoleField/>
                </Can>

                <PinEditableFiled/>

                {/* these password fields are scrambled to prevent autofill */}
                <Fields.Password name="drowssap" new label={<Translation name="fields.new_password.label"/>}/>
                <Fields.Password name="drowssap_confirmation" new
                                 label={<Translation name="fields.confirm_password.label"/>}/>
              </Fieldset>

              <WhenLoaded>
                <Can permission={Permissions.EMPLOYMENTS_MANAGE_USERS_FULL}>
                  <Fieldset innerClassName="my-5">
                    <WhenModelValue name="inactive_at" condition={inactiveAt => inactiveAt === null}>
                      <CancelEmploymentForm/>
                    </WhenModelValue>
                    <WhenModelValue name="active" condition={active => active !== true}>
                      <FiredAtBadge/>
                    </WhenModelValue>
                    <WhenModelValue name="active">
                      <WhenModelValue name="inactive_at">
                        <StopEmploymentCancellationForm/>
                      </WhenModelValue>
                    </WhenModelValue>
                  </Fieldset>
                </Can>
              </WhenLoaded>
              <Fieldset>
                <Fields.TabsField
                        name="is_shared"
                        enum="boolean_status"
                        defaultValue={0}
                        label={<Translation name="fields.is_shared.label"/>}
                />
              </Fieldset>
            </UI.CardWithHeader>
          </CanEither>
  )
}
